import React from 'react';

const DashboardPreview = () => {
  return (
    <svg width="800" height="450" viewBox="0 0 800 450" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="800" height="450" rx="12" fill="white"/>
      
      {/* Left sidebar */}
      <rect x="0" y="0" width="80" height="450" fill="#f0f0f0"/>
      <circle cx="40" cy="40" r="20" fill="#482673"/>
      <rect x="20" y="100" width="40" height="4" rx="2" fill="#6B5A7E"/>
      <rect x="20" y="120" width="40" height="4" rx="2" fill="#6B5A7E"/>
      <rect x="20" y="140" width="40" height="4" rx="2" fill="#6B5A7E"/>
      <rect x="20" y="160" width="40" height="4" rx="2" fill="#6B5A7E"/>
      <rect x="20" y="180" width="40" height="4" rx="2" fill="#6B5A7E"/>
      
      {/* Top bar */}
      <rect x="80" y="0" width="720" height="60" fill="#F8F8F8"/>
      <rect x="100" y="20" width="300" height="20" rx="4" fill="#E0E0E0"/>
      <circle cx="750" cy="30" r="15" fill="#f0f0f0"/>
      <circle cx="710" cy="30" r="15" fill="#E0E0E0"/>
      
      {/* Content */}
      <text x="110" y="100" fontSize="24" fontWeight="bold" fill="#f0f0f0">Hey there, Jane</text>
      <text x="110" y="130" fontSize="14" fill="#666">Here's what's happening in your Brainy AI today</text>
      
      {/* Metrics */}
      <rect x="110" y="160" width="150" height="120" rx="8" fill="#F8F8F8"/>
      <text x="130" y="190" fontSize="24" fontWeight="bold" fill="#f0f0f0">134</text>
      <text x="130" y="210" fontSize="14" fill="#666">Learning Hours</text>
      
      <rect x="280" y="160" width="150" height="120" rx="8" fill="#F8F8F8"/>
      <text x="300" y="190" fontSize="24" fontWeight="bold" fill="#f0f0f0">25</text>
      <text x="300" y="210" fontSize="14" fill="#666">Completed Goals</text>
      
      <rect x="450" y="160" width="150" height="120" rx="8" fill="#F8F8F8"/>
      <text x="470" y="190" fontSize="24" fontWeight="bold" fill="#f0f0f0">87</text>
      <text x="470" y="210" fontSize="14" fill="#666">Knowledge Points</text>
      
      <rect x="620" y="160" width="150" height="120" rx="8" fill="#F8F8F8"/>
      <text x="640" y="190" fontSize="24" fontWeight="bold" fill="#f0f0f0">22</text>
      <text x="640" y="210" fontSize="14" fill="#666">Study Streak</text>
      
      {/* Activity section */}
      <text x="110" y="320" fontSize="18" fontWeight="bold" fill="#f0f0f0">Activity</text>
      <rect x="110" y="340" width="660" height="80" rx="8" fill="#F8F8F8"/>
      
      {/* Right panel */}
      <rect x="580" y="80" width="190" height="240" rx="8" fill="#F8F8F8"/>
      <text x="600" y="110" fontSize="16" fontWeight="bold" fill="#f0f0f0">March 2025</text>
      <text x="600" y="150" fontSize="14" fill="#666">MRR as of Mar 2025</text>
      <text x="600" y="180" fontSize="24" fontWeight="bold" fill="#f0f0f0">$137,445.24</text>
    </svg>
  );
};

export default DashboardPreview; 